"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCountdown = void 0;
var usehooks_ts_1 = require("usehooks-ts");
var react_1 = require("react");
var useCountdown = function (intervals, onStart, onEnd) {
    var _a = (0, usehooks_ts_1.useCountdown)({
        countStart: intervals,
        intervalMs: 1000,
    }), count = _a[0], _b = _a[1], startCountdown = _b.startCountdown, stopCountdown = _b.stopCountdown, resetCountdown = _b.resetCountdown;
    var start = function () {
        onStart();
        startCountdown();
    };
    (0, react_1.useEffect)(function () {
        if (count === 0) {
            onEnd();
            resetCountdown();
        }
    }, [count]);
    return [
        count,
        {
            startCountdown: start,
            stopCountdown: stopCountdown,
            resetCountdown: resetCountdown,
        }
    ];
};
exports.useCountdown = useCountdown;
//# sourceMappingURL=index.js.map